export default __webpack_public_path__ + "static/media/eric.6c4a770b.png";